module.exports = __webpack_public_path__ + "static/img/product_4_3.1063a6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_4_3.png
// module id = dRuH
// module chunks = 34